import { Context, Plugin } from '@segment/analytics-node'
import cookies from 'js-cookie'

import { dataAnonymizer } from '../helpers/dataAnonymizer'

const applyAnonymization = (propertiesToAnonymize: string[]) => (ctx: Context) => {
  const { properties, context } = ctx.event
  const trackingConsented = cookies.get('trackingConsented') === 'true'

  if (!trackingConsented) {
    if (!propertiesToAnonymize) {
      ctx.updateEvent('type', undefined)
      return ctx
    }
    const modifiedProperties = dataAnonymizer(properties, propertiesToAnonymize)
    const modifiedContext = {
      ...context,
      traits: {
        is_anonymized: true,
      },
    }
    ctx.updateEvent('properties', modifiedProperties)
    ctx.updateEvent('context', modifiedContext)
  }

  return ctx
}

export const createAnonymizeTrackPlugin = (
  propertiesToAnonymize: string[]
): Plugin => ({
  name: 'AnonymizeTrack',
  version: '1.0.0',
  isLoaded: () => true,
  type: 'enrichment',
  load: () => Promise.resolve(),
  track: applyAnonymization(propertiesToAnonymize),
  page: applyAnonymization(propertiesToAnonymize),
})

export default createAnonymizeTrackPlugin
